// @flow
import React from 'react'
import ProductItem from '../ProductItem'

type Props = {
  addToCart: Function,
  cartID: number,
  cartItems: Object,
  products: Array<{
    id: number,
    medias: Object,
    name: string,
    price: string
  }>
}

export const Products = (props: Props) => (
  <>
    {props.products.map((product, index) => (
      <ProductItem
        key={product.id}
        addToCart={props.addToCart}
        cartID={props.cartID}
        id={product.id}
        image={product.medias}
        name={product.name}
        numItems={props.cartItems[product.id]}
        price={product.price}
      />
    ))}
  </>
)

export default Products
